module.exports = __webpack_public_path__ + "img/img_3.237b430e.png";